<template>
  <div class="leaflet-map-root">
    <div ref="canvas" class="leaflet-map-canvas"></div>
    <div class="leaflet-map-children"><slot /></div>
  </div>
</template>

<script>
function normalizePosition(position) {
  if (!position) return null

  const lat = typeof position.lat === 'function' ? position.lat() : position.lat
  const lng = typeof position.lng === 'function' ? position.lng() : position.lng
  const parsedLat = Number(lat)
  const parsedLng = Number(lng)

  return Number.isFinite(parsedLat) && Number.isFinite(parsedLng)
    ? [parsedLat, parsedLng]
    : null
}

export default {
  name: 'LeafletMap',
  props: {
    center: { type: Object, default: () => ({ lat: -2.5489, lng: 118.0149 }) },
    zoom: { type: Number, default: 5 },
    options: { type: Object, default: () => ({}) },
    mapTypeId: { type: String, default: '' }
  },
  data() {
    const context = {
      map: null,
      waiting: [],
      whenReady(callback) {
        if (this.map) callback(this.map)
        else this.waiting.push(callback)
      }
    }

    return { mapContext: context }
  },
  provide() {
    return { leafletMapContext: this.mapContext }
  },
  watch: {
    center: {
      deep: true,
      handler(value) {
        const position = normalizePosition(value)
        if (this.mapContext.map && position) this.mapContext.map.panTo(position)
      }
    },
    zoom(value) {
      if (this.mapContext.map && Number.isFinite(Number(value))) {
        this.mapContext.map.setZoom(Number(value))
      }
    }
  },
  mounted() {
    if (!window.L) {
      console.error('Leaflet gagal dimuat.')
      return
    }

    const position = normalizePosition(this.center) || [-2.5489, 118.0149]
    const map = window.L.map(this.$refs.canvas, {
      zoomControl: this.options.zoomControl !== false,
      scrollWheelZoom: this.options.scrollwheel !== false
    }).setView(position, Number(this.zoom) || 5)

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map)

    this.$mapObject = map
    this.mapContext.map = map
    this.mapContext.waiting.splice(0).forEach(callback => callback(map))
    this.$emit('ready', map)

    this.$nextTick(() => map.invalidateSize())
    setTimeout(() => map.invalidateSize(), 250)
  },
  beforeDestroy() {
    if (this.mapContext.map) this.mapContext.map.remove()
    this.mapContext.map = null
  }
}
</script>

<style scoped>
.leaflet-map-root,
.leaflet-map-canvas {
  width: 100%;
  height: 100%;
  min-height: 300px;
}

.leaflet-map-root {
  position: relative;
}

.leaflet-map-children {
  display: none;
}
</style>
